import * as PIXI from "pixi.js";

import { TGameAssetAlias } from "@src/game/screens/GameScreen";
import { IView } from "@src/core/game/components/IView";
import { Assets } from "@src/core/assets/Assets";

export enum EJackpotTier {
  MINOR = "MINOR",
  MIDI = "MIDI",
  MAJOR = "MAJOR",
  GRAND = "GRAND",
}

export class JackpotTierView implements IView {
  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private _textStyle: PIXI.TextStyle = new PIXI.TextStyle({
    fontSize: 50,
    fontFamily: "gameFont",
    align: "center",
    wordWrap: false,
    wordWrapWidth: 700,
    fill: 0xffbb1e,
    letterSpacing: 0,
    lineHeight: 38,
    padding: 4,
  });

  public constructor(type: EJackpotTier) {
    const gameAtlasSpritesheet1 =
      Assets.getAsset<TGameAssetAlias>("atlasGame1");

    this._view = new PIXI.Container();
    const label: PIXI.Text = new PIXI.Text({
      text: "",
      style: this._textStyle,
    });
    label.anchor.set(0.5);
    label.x = 10;

    let textureName: string = "";

    switch (type) {
      case EJackpotTier.MINOR:
        textureName = "jackpot_minor_tier.webp";
        label.text = "100.00";
        label.y = 65;
        break;
      case EJackpotTier.MIDI:
        textureName = "jackpot_midi_tier.webp";
        label.text = "250.00";
        label.y = 70;
        break;
      case EJackpotTier.MAJOR:
        textureName = "jackpot_major_tier.webp";
        label.text = "500.00";
        label.y = 75;
        break;
      case EJackpotTier.GRAND:
        textureName = "jackpot_grand_tier.webp";
        label.text = "2500.00";
        label.y = 80;
        break;
    }

    const sprite: PIXI.Sprite = new PIXI.Sprite(
      gameAtlasSpritesheet1.textures[textureName],
    );
    sprite.anchor.set(0.5);

    this._view.addChild(sprite, label);
  }
}
